import { ethers } from 'ethers';

export function parseSREP(value: string): ethers.BigNumber {
  return ethers.BigNumber.from(value)
    .div(ethers.BigNumber.from(10).pow(18))
    .div(24 * 60 * 60);
}
